import * as Alt from 'alt';

const alt = new Alt();

export default alt;



// WEBPACK FOOTER //
// ./javascripts/components/alt.js